export default {
    create_edit_webhook_create_title: 'Create Webhook',
    create_edit_webhook_edit_title: 'Edit Webhook',
    create_edit_webhook_name: 'Name',
    create_edit_webhook_action: 'Action (Webhook URL)',
    create_edit_webhook_event_type: 'Event Type',
    create_edit_webhook_status: 'Active',
    create_edit_webhook_headers: 'Advanced: Headers (Optional)',
    create_edit_webhook_headers_help: 'Optional custom headers in JSON format',
    create_edit_webhook_name_required: 'Name is required',
    create_edit_webhook_url_required: 'URL is required',
    create_edit_webhook_url_invalid: 'Invalid URL format',
    create_edit_webhook_event_type_required: 'Event Type is required',
    create_edit_webhook_created: 'Webhook created successfully',
    create_edit_webhook_updated: 'Webhook updated successfully',
    create_edit_webhook_duplicate_error: 'A webhook for this event type already exists. Edit it instead.',
    create_edit_webhook_invalid_params: 'Invalid parameters. Please check your input.',
    create_edit_webhook_unauthorized: 'You are not authorized to perform this action.',
    create_edit_webhook_record_not_exist: 'The webhook or dealer does not exist.',
    create_edit_webhook_error: 'Failed to save webhook. Please try again.',
};
